import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import { PasswordField, SubmitButton } from './FormFields';
import api from '../../services/api';
import API from '../../config/apiEndpoints';
import { Key, Lock, ArrowLeft } from '../Icons';

// Opened from the reset email: /reset-password?email=...&token=...
export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const email = params.get('email') || '';
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const er = {};
    if (password.length < 8) er.password = 'Use at least 8 characters.';
    else if (!/[A-Z]/.test(password) || !/[a-z]/.test(password) || !/\d/.test(password) || !/[^A-Za-z0-9]/.test(password)) {
      er.password = 'Use upper and lower case letters, a number and a symbol.';
    }
    if (confirm !== password) er.confirm = 'Passwords don’t match.';
    setErrors(er);
    if (Object.keys(er).length) return;

    setLoading(true);
    try {
      await api.post(API.auth.resetPassword, { email, token, newPassword: password }, { skipAuthRefresh: true });
      navigate('/login', { replace: true, state: { notice: 'Password changed. You can log in now.' } });
    } catch (err) {
      setErrors({ password: err.message || 'This reset link is invalid or has expired.' });
    } finally {
      setLoading(false);
    }
  };

  if (!email || !token) {
    return (
      <AuthLayout title="Link not valid" subtitle="This password reset link is incomplete." footer={<Link to="/login" className="auth__back-link"><ArrowLeft width={16} height={16} /> Back to log in</Link>}>
        <Link to="/forgot-password" className="btn btn--primary btn--block">Request a new link</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Choose a new password"
      subtitle={`For ${email}`}
      footer={<Link to="/login" className="auth__back-link"><ArrowLeft width={16} height={16} /> Back to log in</Link>}
    >
      <div className="auth__badge"><Key width={22} height={22} /></div>
      <form className="auth__form" onSubmit={onSubmit} noValidate>
        <PasswordField id="password" label="New password" icon={Lock} autoComplete="new-password" value={password} onChange={(e) => { setPassword(e.target.value); setErrors({}); }} error={errors.password} autoFocus />
        <PasswordField id="confirm" label="Confirm new password" icon={Lock} autoComplete="new-password" value={confirm} onChange={(e) => { setConfirm(e.target.value); setErrors({}); }} error={errors.confirm} />
        <SubmitButton loading={loading}>{loading ? 'Saving…' : 'Change password'}</SubmitButton>
      </form>
    </AuthLayout>
  );
}
